<div class="col-lg-12 row" [formGroup]="orderForm">
  <div class="col-lg-4">
    <mat-card class="bill-address">
      <p i18n *ngIf="article.id != 3" class="title">1. BILLING ADDRESS</p>
      <p i18n *ngIf="article.id == 3" class="title">BILLING ADDRESS</p>
      <div class="address-body">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label i18n for="firstname"> <span class="obligatory">*</span> First name</label>
            <input type="text" class="form-control" formControlName="firstName">
          </div>
          <div class="form-group col-md-6">
            <label i18n for="lastname"><span class="obligatory">*</span>Last name</label>
            <input type="text" class="form-control" formControlName="lastName">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label i18n for="inputEmail4"> <span class="obligatory">*</span> Email</label>
            <input type="email" class="form-control" formControlName="emailReferens">
          </div>
          <div class="form-group col-md-6">
            <label i18n for="telephone"><span class="obligatory">*</span>Telephone</label>
            <input type="text" class="form-control" formControlName="phone">
          </div>
        </div>
        <div class="form-group">
          <label i18n for="inputAddress" *ngIf="!orderForm.value.otherShippingAddress"><span class="obligatory">*</span>Shipping and billing address</label>
          <label i18n for="inputAddress" *ngIf="orderForm.value.otherShippingAddress"><span class="obligatory">*</span>Billing address</label>
          <input type="text" class="form-control" formControlName="address">
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label i18n for="inputCity"><span class="obligatory">*</span>City</label>
            <input type="text" class="form-control" formControlName="city">
          </div>
          <div class="form-group col-md-6">
            <label i18n for="inputZip"><span class="obligatory">*</span>Zip / Postal code</label>
            <input type="text" class="form-control" formControlName="zipcode">
          </div>
        </div>
        <div class="form-group">
          <label i18n for="inputCountry"><span class="obligatory">*</span>Country</label>
          <select id="inputCountry" class="form-control" formControlName="country">
            <option i18n  *ngFor="let item of countries" [value]="item.country">{{item.country}}
            </option>
          </select>
        </div> 
        <div class="form-group" *ngIf="country.province.length >= 1">
          <label i18n for="inputProvince"><span class="obligatory">*</span>Province/State</label>
          <select id="inputProvince" class="form-control" formControlName="province">
            <option i18n  *ngFor="let item of country.province" [value]="item.name">{{item.name}}
            </option>
          </select>
        </div>
        <div class="form-group">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="otherShippingAddress">
            <label i18n class="form-check-label" for="gridCheck">
              Ship to different address
            </label>
          </div>
        </div>
        <div *ngIf="orderForm.value.otherShippingAddress">
          <div class="form-group">
            <label i18n for="inputAddress"><span class="obligatory">*</span>Shipping address</label>
            <input type="text" class="form-control" formControlName="address_2">
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label i18n for="inputCity"><span class="obligatory">*</span>City</label>
              <input type="text" class="form-control" formControlName="city_2">
            </div>
            <div class="form-group col-md-6">
              <label i18n for="inputZip"><span class="obligatory">*</span>Zip / Postal code</label>
              <input type="text" class="form-control" formControlName="zipcode_2">
            </div>
          </div>
          <div class="form-group">
            <label i18n for="inputCountry"><span class="obligatory">*</span>Country</label>
            <select id="inputCountry" class="form-control" formControlName="country_2">
              <option i18n  *ngFor="let item of countries" [value]="item.country">{{item.country}}
              </option>
            </select>
          </div>
          <div *ngIf="country_2">
            <div class="form-group" *ngIf="country_2.province.length >= 1">
              <label i18n for="inputProvince"><span class="obligatory">*</span>Province/State</label>
              <select id="inputProvince" class="form-control" formControlName="province_2">
                <option i18n  *ngFor="let item of country_2.province" [value]="item.name">{{item.name}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

    </mat-card>
  </div>
  <div class="col-lg-4">
    <mat-card class="shipping-method" *ngIf="article.id != 3">
      <p i18n  class="title">2. SHIPPING METHOD</p>
      <div class="body">
        <p i18n  class="sub-title">Shipping method</p>
        <div class="form-group">
          <select formControlName="shipment_method" class="form-control">
            <option   *ngFor="let item of shipping_methods" [ngValue]="item">{{item.days}} <span i18n>Day Delivery</span> - <app-currency-converter [data]="{price:item.price, country: country.country}"></app-currency-converter></option>
          </select>
        </div>
      </div>
    </mat-card> 
    <mat-card class="discounts">
        <p i18n class="title">Discounts</p>
        <p i18n class="desc">Enter a discount code below to apply it to this order.</p>
        <div class="code">
            <label i18n for="code">Code</label>
            <input type="text" id="code" formControlName="discountCode">
            <button i18n class="apply" (click)="applyDiscount(orderForm.value.discountCode)">APPLY</button>
        </div>
        <p i18n class="invalid-discount-text" *ngIf="totalDiscount ==  0 || invalidDiscount">Invalid discount code.</p>
        <p i18n class="invalid-discount-text" *ngIf="discountLow">This code is not applied due to lower discountprocentage.</p>
    </mat-card>
  </div>
  <div class="col-lg-4">
    <mat-card class="review-order">
      <p i18n *ngIf="article.id != 3" class="title">3. REVIEW YOUR ORDER</p>
      <p i18n *ngIf="article.id == 3" class="title">REVIEW YOUR ORDER</p>
      <div class="body">
        <div class="header">
          <p i18n  class="w-3 left"></p>
          <p i18n  class="w-3"></p>
          <p i18n  class="w-3 right">Subtotal</p>
        </div>
        <div class="content">
          <p i18n  class="w-3 left">{{article.title}}</p>
          <p i18n  class="w-3 mid">{{article.quantity}}</p>
          <p i18n  class="w-3 right"><app-currency-converter [data]="{price:article.price  * article.quantity, country: country.country}"></app-currency-converter></p>
        </div>
        <div class="content" *ngIf="totalDiscount && totalDiscount != 0">
          <p i18n  class="w-3 left" *ngIf="this.discount.id != this.organization.discountCodeId">{{this.discount.code}} - {{this.discount.procentage * 100}}% discount</p>
          <p  class="w-3 left" *ngIf="this.discount.id == this.organization.discountCodeId">{{this.organization.name}} - {{this.discount.procentage * 100}}% discount</p>
          <p i18n  class="w-3 mid"></p>
          <p i18n  class="w-3 right">-<app-currency-converter [data]="{price:totalDiscount, country: country.country}"></app-currency-converter></p>
        </div>
        <div class="content" *ngIf="article.id != 3">
          <p i18n  class="w-3 left">Shipping price</p>
          <p i18n  class="w-3 mid"></p>
          <p i18n  class="w-3 right"><app-currency-converter [data]="{price:orderForm.value.shipment_method['price'], country: country.country}"></app-currency-converter></p>
        </div>         
        <div class="content">
          <p i18n  class="w-3 left">VAT</p>
          <p i18n  class="w-3 mid"></p>
          <p i18n  class="w-3 right"><app-currency-converter [data]="{price:vat, country: country.country}" ></app-currency-converter></p>
        </div>
      </div>
      <div class="body">
        <div class="header">
          <p i18n  class="w-3"></p>
          <p i18n  class="w-3"></p>
          <p i18n  class="w-3 right">Cost</p>
        </div>
        <div class="content">
          <p i18n  class="w-3"></p>
          <p i18n  class="w-3"></p>
          <p i18n  class="w-3 right"><app-currency-converter [data]="{price:totalPrice, country: country.country}"></app-currency-converter></p>
        </div>
        <div *ngIf="country.currency != 'EUR'">
          <p i18n class="currency-disclamer">Please note that the price at the time of purchase may vary due to currency conversion (EUR).</p>
        </div>
      </div>
    </mat-card>
    <!-- <mat-card class="note">
      <p i18n  class="title">Customer Note</p>
      <p i18n  class="desc">Here you can write a comment to customer service if you need to.</p>
      <textarea id="" cols="30" rows="5" class="form-control" formControlName="coustumerMessage" maxlength="150"></textarea>
    </mat-card> -->
    <mat-card class="note">
      <button i18n class="checkout" (click)="checkout()" [disabled]="!this.orderForm.valid">CHECKOUT</button>
    </mat-card>
  </div>
</div>